import * as Auth from '@app/state/authenticate'
import * as AuthState from '@app/state/authenticate/state'
import * as Clinic from '@app/state/clinic'
import * as Config from '@app/state/config'
import * as DomainEvents from '@app/state/domain-events'
import * as FeatureFlags from '@app/state/feature-flags'
import * as Init from '@app/state/init'
import * as InstrumentList from '@app/state/instrument-list'
import * as Intake from '@app/state/intake'
import * as PatientList from '@app/state/patient-list'
import * as Patients from '@app/state/patients'
import * as Program from '@app/state/program'
import * as ProgramScreen from '@app/state/program_screen'
import * as Today from '@app/state/today'
import * as User from '@app/state/user'
import * as VisitList from '@app/state/visit-list'
import * as Visits from '@app/state/visits'

// TODO: do we need this one or RootState?
export interface AppState {
  auth: Auth.State
  clinic: Clinic.State
  config: Config.State
  domainEvents: DomainEvents.State
  featureFlags: FeatureFlags.State
  init: Init.State
  instrumentList: InstrumentList.State
  intake: Intake.State
  user: User.State
  visitList: VisitList.State
  visits: Visits.State
  patients: Patients.State
  program: Program.State
  programScreen: ProgramScreen.State
  today: Today.State
  patientList: PatientList.State
}

export type AppAction =
  | Auth.Action
  | Clinic.Action
  | Config.Action
  | DomainEvents.Action
  | FeatureFlags.Action
  | Init.Action
  | InstrumentList.Action
  | Intake.Action
  | User.Action
  | VisitList.Action
  | Visits.Action
  | Patients.Action
  | Program.Action
  | ProgramScreen.Action
  | Today.Action
  | PatientList.Action

export type RootState = {
  auth: Auth.State
  clinic: Clinic.State
  config: Config.State
  domainEvents: DomainEvents.State
  featureFlags: FeatureFlags.State
  init: Init.State
  instrumentList: InstrumentList.State
  intake: Intake.State
  user: User.State
  visitList: VisitList.State
  visits: Visits.State
  patients: Patients.State
  program: Program.State
  programScreen: ProgramScreen.State
  today: Today.State
  patientList: PatientList.State
}

export const initialState = {
  auth: Auth.initialState,
  clinic: Clinic.initialState,
  config: Config.initialState,
  domainEvents: DomainEvents.initialState,
  featureFlags: FeatureFlags.initialState,
  init: Init.initialState,
  instrumentList: InstrumentList.initialState,
  intake: Intake.initialState,
  user: User.initialState,
  visitList: VisitList.initialState,
  visits: Visits.initialState,
  patients: Patients.initialState,
  program: Program.initialState,
  programScreen: ProgramScreen.initialState,
  today: Today.initialState,
  patientList: PatientList.initialState,
}

export const reducers = {
  auth: AuthState.reducer,
  clinic: Clinic.reducer,
  config: Config.reducer,
  domainEvents: DomainEvents.reducer,
  featureFlags: FeatureFlags.reducer,
  init: Init.reducer,
  instrumentList: InstrumentList.reducer,
  intake: Intake.reducer,
  user: User.reducer,
  visitList: VisitList.reducer,
  visits: Visits.reducer,
  patients: Patients.reducer,
  patientList: PatientList.reducer,
  program: Program.reducer,
  programScreen: ProgramScreen.reducer,
  today: Today.reducer,
}

// Note that all boot time sagas need to have unique function names or
// else they will be overwritten by a later saga by the same name
export const bootTimeSagas: { [key: string]: () => IterableIterator<unknown> } =
  {
    ...Auth.sagas,
    ...Clinic.sagas,
    ...DomainEvents.sagas,
    ...FeatureFlags.sagas,
    ...Intake.sagas,
    ...Visits.sagas,
    ...VisitList.sagas,
    ...Patients.sagas,
    ...PatientList.sagas,
    ...Program.sagas,
    ...ProgramScreen.sagas,
    ...User.sagas,
    ...Today.sagas,
  }
